import React, {useState} from "react";
import {Col, FormGroup, Input, Row} from "reactstrap";
import {every, isEmpty} from "lodash";
import {useSelector} from "react-redux";
import {
  getEditInventoryData,
  getSimDropdownData,
} from "../../../../redux/Selectors/inventory.selector";
import Select from "react-select";
import {toast} from "react-toastify";

const INITIAL_LOCAL_STATE = {
  mac: "",
  sim: {},
};

const MANDATORY_KEYS = ["mac"];

function DetailedInformation(_props, ref) {
  const simDropdownData = useSelector(getSimDropdownData);
  const editInventoryData = useSelector(getEditInventoryData);
  const getEditData = editInventoryData ? editInventoryData : {};
  const {detailedInfo = {}} = getEditData;
  const [detailFormObject, setDetailFormObject] = useState(() =>
    !isEmpty(detailedInfo) ? detailedInfo : INITIAL_LOCAL_STATE
  );
  const [submitted, setSubmitted] = useState(false);

  const checkForValidation = () => {
    const validated = every(MANDATORY_KEYS, (each) => !!detailFormObject[each]);

    setSubmitted(true);
    if (!validated) {
      toast.error("Please check required fields");
    }
    return validated;
  };

  /* ## This Imperative Handle and customizes the instance value that is exposed to parent components when using ref. Please Don't Remove this Line ## */
  React.useImperativeHandle(ref, () => {
    return {
      isValidated: () => {
        return checkForValidation();
      },
      state: detailFormObject,
    };
  });

  const onChangeHandler = (e, type) => {
    if (type === 1) {
      setDetailFormObject({
        ...detailFormObject,
        [e.target.name]: e.target.value,
      });
    } else {
      setDetailFormObject({
        ...detailFormObject,
        selectedSim: e,
        sim: e ? e.value : "",
      });
    }
  };

  const {mac, selectedSim} = detailFormObject;
  return (
    <div className="pl-lg-4">
      <Row>
        <Col md="12">
          <FormGroup>
            <label className="form-control-label" htmlFor="input-mac">
              MAC Address <span className="text-red">*</span>
            </label>
            <Input
              className="form-control-alternative"
              id="input-mac"
              placeholder="Name"
              type="text"
              value={mac}
              name="mac"
              data-cy="mac"
              invalid={isEmpty(mac) && submitted}
              onChange={(e) => onChangeHandler(e, 1)}
              disabled={editInventoryData.detailedInfo}
            />
          </FormGroup>
        </Col>
      </Row>
      <Row>
        <Col md="12">
          <FormGroup>
            <label className="form-control-label" htmlFor="input-root-domain">
              SIM
            </label>
            <Select
              closeMenuOnSelect={true}
              options={simDropdownData}
              value={selectedSim}
              isClearable={true}
              classNamePrefix={"select_sim"}
              id={"select_sim"}
              onChange={(e) => onChangeHandler(e, 2)}
            />
          </FormGroup>
        </Col>
      </Row>
    </div>
  );
}

DetailedInformation.propTypes = {};

export default React.forwardRef(DetailedInformation);
